/**
 * Совпадения: агрегат на пару (BS §10.1, GAP-ALL-07).
 */
import type { Match } from '@shared/api/types'
import { matchesRepo, useReplica } from '@shared/db'

export function useNewMatchesCount(): number {
  return useReplica(
    async () => {
      const items = await matchesRepo.listActive()
      return items.filter((m) => !m.seen).length
    },
    [],
    0,
  )
}

/** Совпадения без начатого диалога — верхняя лента экрана M-01 (ПС §10). */
export function useMatchesWithoutMessages(): Match[] {
  return useReplica(
    async () => {
      const items = await matchesRepo.listActive()
      return items.filter((m) => !m.has_messages)
    },
    [],
    [],
  )
}
